import { Entity } from '../../domain/entity'
import { hashCode } from '../common/hash-code'
import { prune } from '../common/prune'

export interface IStorageItem<T> {
    data: T
    exp: number
    ts: number
    isValid(): boolean
    toString(): string
}

export class StorageItem<T> extends Entity implements IStorageItem<T> {
    public static defaultExpireMs = 604800000 // 7 days

    constructor(
        public data: T,
        public readonly exp = StorageItem.defaultExpireMs,
        public readonly ts = Date.now(),
        protected mac?: number
    ) {
        super()
        if (!mac) {
            this.updateHash()
        }
    }

    public fromJson(data: object): any {
        super.fromJson(data)

        if (data && (data as this).data) {
            this.data = (data as this).data

            if (!this.mac) {
                this.updateHash()
            }
        }
    }

    /**
     * Checks mac and expiry.
     */
    public isValid() {
        const { mac: _, ...rest } = prune(this)
        return this.mac === hashCode(rest) && (this.exp === 0 || (Date.now() - this.ts) < this.exp)
    }

    public toString() {
        return JSON.stringify(prune(this))
    }

    protected updateHash() {
        const { mac, ...rest } = prune(this)
        this.mac = hashCode(rest)
    }
}
